// extracted by mini-css-extract-plugin
export default {"Label":"TextArea_Label__AofFAf7V","Input":"TextArea_Input__+M5msmhY","HasError":"TextArea_HasError__YhM++nrx","Error":"TextArea_Error__ozaVxxYU"};